var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { useRefs } from "../hooks/useRef";
import { syncScroll } from "../utils/dom";
export function Element(_a) {
    var { children, domRef, tagName, scroll: { x: scrollLeft, y: scrollTop } = { x: 0, y: 0 } } = _a, props = __rest(_a, ["children", "domRef", "tagName", "scroll"]);
    const [ref, setRef] = useRefs(domRef);
    React.useEffect(() => syncScroll({ scrollTop, scrollLeft }, ref), [ref, scrollLeft, scrollTop]);
    // For attributes that are not always updated when the prop is removed
    React.useEffect(
    /** Manually reset missing values */ () => {
        const valueResetMap = { value: "" };
        Object.entries(valueResetMap).forEach(([name, resetValue]) => {
            var _a;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            if (ref)
                ref[name] = (_a = props[name]) !== null && _a !== void 0 ? _a : resetValue;
        });
    }, [ref, props]);
    return React.createElement(tagName.toLowerCase(), Object.assign(Object.assign({}, props), { ref: setRef }), ...(Array.isArray(children) ? children : [children]));
}
